// extracted by mini-css-extract-plugin
export default {"PfsWhoWeAreCollage":"PFSWhoWeAreCollage_PfsWhoWeAreCollage__xxHfy","StaffImages":"PFSWhoWeAreCollage_StaffImages__EDD2b"};